import { useState } from 'react';
import { Icon } from 'react-icons-kit';
import { eye } from 'react-icons-kit/feather/eye';
import { eyeOff } from 'react-icons-kit/feather/eyeOff';
import { Link, useNavigate } from 'react-router-dom';

import Logo from '../../assets/logo-dark.png';
import Loading from '../../components/Loading/Loading.jsx';
import { loginUserWithEmailAndPassword } from '../../lib/firebase/Authentication/EmailAuth/index.js';
import { loginWithGoogle } from '../../lib/firebase/Authentication/GoogleAuth/index.js';
import Styles from '../../styles/Auth.module.css';

const Login = ({ setAuth }) => {
  const [error, setError] = useState(false);
  const [googleError, setGoogleError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const [type, setType] = useState('password');
  const [icon, setIcon] = useState(eyeOff);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const { email, password } = formData;

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleToggleEye = () => {
    if (type === 'password') {
      setIcon(eye);
      setType('text');
    } else {
      setIcon(eyeOff);
      setType('password');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    loginUserWithEmailAndPassword(
      email,
      password,
      setIsLoading,
      navigate,
      setError,
    );
  };

  const handleGoogleLogin = () => {
    setGoogleError('');
    loginWithGoogle(navigate, setIsLoading);
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className={Styles.page}>
      <div className={Styles.headerContainer}>
        <img
          className={Styles.logoIcon}
          src={Logo}
          alt={'Website logo'}
          onClick={() => navigate('/')}
        />
        <div className={Styles.headerActions}>
          <button
            type="button"
            className={`${Styles.headerBtn} ${Styles.headerBtnPrimary}`}
            onClick={() => navigate('/signup')}
          >
            Sign up
          </button>
        </div>
      </div>
      <div className={Styles.container}>
        <form onSubmit={(e) => handleSubmit(e)}>
          <div className={Styles.title}>
            <h1>Log In</h1>
          </div>
          <div className={Styles.inputs}>
            <label>Email</label>
            <div className={Styles.input}>
              <input
                type="text"
                name="email"
                value={email}
                onChange={(e) => onChange(e)}
              />
            </div>
            <label>Password</label>
            <div className={Styles.input}>
              <input
                type={type}
                name="password"
                value={password}
                onChange={(e) => onChange(e)}
              />
              <Icon
                className={Styles.eye}
                icon={icon}
                size={20}
                onClick={handleToggleEye}
              />
            </div>
          </div>
          <div className={Styles.forgotPasswordContainer}>
            <h4
              className={Styles.forgotPassword}
              onClick={() => navigate('/forgot-password')}
            >
              Forgot Password
            </h4>
          </div>
          <button type="submit" className={Styles.loginBtn}>
            Log in
          </button>
          <div className={Styles.errorContainer}>
            {error ? <p>Invalid email or password.</p> : <></>}
          </div>
          <p className={Styles.orSeparator}>
            <span>OR</span>
          </p>
        </form>
        <button
          type="button"
          className={Styles.loginWithGoogleBtn}
          onClick={handleGoogleLogin}
        >
          Log in with Google
        </button>
        {googleError && (
          <div className={Styles.errorContainer}>
            <p>{googleError}</p>
          </div>
        )}
        <p className={Styles.switchPrompt}>
          New to Brassflows?
          <Link to="/signup" className={Styles.switchLink}>
            Create an account
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;